import s from "./IcdDropdown.module.css";

export const IcdDropdown = ({ search, codes, isLoading, onSelect }) => {
  const renderContent = () => {
    if (search.length < 3) {
      return (
        <div className={s.item}>Type at least 3 characters to search for ICD-10 codes</div>
      );
    }
    if (isLoading) {
      return <div className={s.item}>Loading...</div>;
    }
    if (!codes?.length) {
      return <div className={s.item}>No ICD-10 codes found for &quot;{search}&quot;</div>;
    }
    return codes.map((code) => (
      <div key={code.id} className={s.item} onClick={() => onSelect(code)}>
        <div className={s.code}>{code.code}</div>
        <div className={s.details}>
          <span className={s.type}>ICD Type: {code.icdType}</span>
          <span>{code.name}</span>
        </div>
      </div>
    ));
  };

  return <div className={s.dropdown}>{renderContent()}</div>;
};
